import * as yup from "yup";

export const createFaqSectionValidationScheme = yup.object().shape({
  name: yup
    .string()
    .required("Please enter your Name")
    .min(2, ({ min }) => `Name must be at least 2 characters long.`)
    .max(50, ({ max }) => `Name must be the most ${max} characters long.`),
});
